export const LABRADOR_STATIC_SELECTORS = [
  'articlePreHeader',
  'articleHeader',

  'lab-dz-pre-header',
  'lab-dz-header',
  'article-post-header',

  'article-pre-footer',
  'articleFooter',
  'article-post-footer',
];
